import styled from 'styled-components';

const MainHeadingContainer = styled.div`
    text-align: center;
    h2 {
        font-weight: normal;
        font-size: 40px;
        position: relative;
        margin-bottom: 70px;
        text-transform: uppercase;

        &::after {
            content: '';
            height: 2px;
            width: 120px;
            position: absolute;
            bottom: -30px;
            left: 50%;
            transform: translateX(-50%);
            background-color: #333;
        }
        &::before {
            content: '';
            height: 14px;
            width: 14px;
            position: absolute;
            bottom: -38px;
            left: 50%;
            transform: translateX(-50%);
            background-color: white;
            border-radius: 50%;
            border: 2px solid #333;
            z-index: 2;
        }
    }
    p {
        width: 550px;
        margin: 0 auto 100px;
        max-width: 100%;
        line-height: 2;
        color: #777;
    }
`;
export default MainHeadingContainer;
